import React from 'react'

import { Absolute } from '../../../packages/kiti/components/helpers/Position'
import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { useForm } from '../../../packages/kiti/components/form/form/FormHandler'
import { useOpenEditWidgetModal } from '../../../utils/routes/modals/modalsActions'
import { useRemoveScreenItem } from './_requests/removeScreenItem'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Loading from '../../../packages/kiti/components/helpers/Loading'
import Panel from '../../../packages/kiti/components/structure/Panel'

const WidgetControl = ({ widget }) => {
  const { editing, activeTabIndex } = useForm()
  const [remove, { loading }] = useRemoveScreenItem()
  const editWidget = useOpenEditWidgetModal()
  if (loading) return <Loading />
  if (!editing) return false

  return (
    <>
      <Absolute top={0} right={0}>
        <Panel padding={0.3} radius={0} bgColor="light1">
          <Grid gap={0.4} align="center" justify="flex-end">
            <Col>
              <Icon name="IoSettingsOutline" color="dark3" onClick={() => editWidget({ id: widget.id })} />
            </Col>

            <Col>
              <Icon name="IoTrashOutline" color="red" onClick={() => remove(widget.id)} />
            </Col>
          </Grid>
        </Panel>
      </Absolute>
    </>
  )
}

export default WidgetControl
